<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.teams', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <EmptyState picture v-if="teams.length === 0">
            <template v-slot:picture>
                <img src="/img/utils/undraw_blank_canvas_empty_state_positive.svg" alt="empty state" />
            </template>
        </EmptyState>
        <template v-else>
            <AppWell>
                <div class="md:grid md:grid-cols-12 md:gap-6 p-2">
                    <div class="col-span-6" v-for="team in teams" :key="team.id">
                        <AppCard>
                            <div class="font-bold">
                                {{ team.grouping_name }} <span v-if="team.name">( {{ team.name }})</span>
                            </div>
                            <div class="mt-3">
                                <div v-for="student in team.students" :key="student.id">
                                    {{ student.full_name }}
                                </div>
                            </div>
                        </AppCard>
                    </div>
                </div>
            </AppWell>
        </template>

        <template v-slot:pagination>
            <InertiaPagination :paginator="teams" />
        </template>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import EmptyState from '@/components/EmptyState.vue';
import AppWell from '../../../Shared/AppWell.vue';
import AppCard from '../../../Shared/AppCard.vue';

export default {
    components: {
        AppCard,
        AppWell,
        PanelPage,
        InertiaPagination,
        EmptyState,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'teams'],
};
</script>
